<template>
  <div>
    <bread-crumb></bread-crumb>
    <!--    <search></search>-->
    <manFormList
      :select="select"
      :selectList="selectList"
      @selectChenge="selectChenge"
      @empty="empty"
      :num="num"
      :isBtn="isBtn"
      @getChangeValue="getChangeValue"
    >
    </manFormList>
    <div class="content-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <span slot="label" class="slot-item">
            <span>全部</span>
            <span>{{ businessAccountCountStaus.totalCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane name="pending">
          <span slot="label" class="slot-item">
            <span>待审核</span>
            <span>{{ businessAccountCountStaus.unAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane name="passed">
          <span slot="label" class="slot-item">
            <span>已通过</span>
            <span>{{ businessAccountCountStaus.passAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane name="rejected">
          <span slot="label" class="slot-item">
            <span>已驳回</span>
            <span>{{ businessAccountCountStaus.rejectAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane name="frozen">
          <span slot="label" class="slot-item">
            <span>已冻结</span>
            <span>{{ businessAccountCountStaus.frozenCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
      </el-tabs>

      <pagination
        @sizePageChange="paginationChangeProduct"
        :paginationDatas="paginationDataProduct"
      >
      </pagination>

      <modal
        :isShow.sync="auditDialog"
        title="审核"
        :width="width"
        :isShowBtn="isShowBtn"
        :btnText="btnTextAudit"
        @clickHandler="auditClickHandler"
      >
        <el-form
          :model="auditForm"
          label-width="100px"
          class="demo-ruleForm"
          :rules="rules"
          ref="audit"
        >
          <el-form-item label="账号介绍" prop="briefing">
            <span>{{ auditForm.briefing }}</span>
          </el-form-item>
          <el-form-item label="作者链接" prop="exampleUrl">
            <span class="authorUrl">{{ auditForm.exampleUrl }}</span>
          </el-form-item>
          <el-form-item label="作者身份" prop="exampleUrl">
            <el-select
              v-model="auditForm.identityCode"
              placeholder="请选择活动区域"
              size="small"
            >
              <el-option
                v-for="(item, index) in identityList"
                :key="index"
                :label="item.identityDesc"
                :value="item.identityCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联业务">
            <!-- <span class="title">关联业务</span> -->
            <el-select
              v-model="businessTag"
              multiple
              placeholder="请选择"
              size="mini"
              style="width: 200px"
              class="selectBus"
            >
              <el-option
                v-for="item in businessOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="审核结果"
            prop="exampleUrl"
            v-if="auditForm.Status === 0 ? false : true"
          >
            <span>驳回</span>
          </el-form-item>
          <el-form-item
            label="驳回理由"
            prop="freeze"
            v-if="auditForm.Status === 0 ? false : true"
          >
            <el-input
              size="small"
              type="textarea"
              placeholder="请输入"
              v-model="auditForm.freeze"
              maxlength="150"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </modal>

      <!-- 修改身份 -->
      <modal
        :isShow.sync="editroleDialog"
        title="修改角色"
        :width="width"
        :isShowBtn="isShowBtn"
        :btnText="btnTextEditrole"
        @clickHandler="editroleClickHandler"
      >
        <el-form
          :model="editroleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="账号介绍" prop="briefing">
            <span>{{ editroleForm.briefing }}</span>
          </el-form-item>
          <el-form-item label="作者链接" prop="exampleUrl">
            <span class="authorUrl"> {{ editroleForm.exampleUrl }}</span>
          </el-form-item>
          <el-form-item label="作者身份" prop="exampleUrl">
            <el-select
              v-model="editroleForm.identityCode"
              placeholder="请选择活动区域"
              size="small"
            >
              <el-option
                v-for="(item, index) in identityList"
                :key="index"
                :label="item.identityDesc"
                :value="item.identityCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联业务">
            <!-- <span class="title">关联业务</span> -->
            <el-select
              v-model="businessTag"
              multiple
              placeholder="请选择"
              size="mini"
              style="width: 200px"
              class="selectBus"
            >
              <el-option
                v-for="item in businessOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </modal>

      <modal
        :width="width"
        :isShow.sync="freezeDialog"
        title="确认冻结"
        :isShowBtn="isShowBtn"
        :btnText="btnTextFreeze"
        @clickHandler="freezeClickHandler"
      >
        <el-form
          :model="freezeForm"
          label-width="100px"
          class="demo-ruleForm"
          :rules="freeze"
        >
          <el-form-item label="冻结理由" prop="freeze">
            <el-input
              size="small"
              type="textarea"
              placeholder="请输入"
              v-model="freezeForm.freeze"
              maxlength="150"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </modal>

      <modal
        :width="width"
        :isShow.sync="formDialog"
        title="申请理由"
        :isShowBtn="isShowBtn"
        :btnText="btnText"
        @clickHandler="ClickHandler"
      >
        <div class="dialog-conter">{{ tableVal.auditRemark }}</div>
      </modal>
    </div>
  </div>
</template>

<script>
import utils from "../../../../utils";
import pagination from "../../../../components/pagination";
import baseTable from "../../../../components/baseTable";
import search from "../../components/search";
import breadCrumb from "../../../../components/breadCrumb";
import dialogForm from "../../../../components/dialogForm";
import modal from "../../../../components/modal";
import manFormList from "../../components/manFormList";
import {
  pageQueryCreatorAccount,
  queryAllIdentity,
  reviewCreatorAccount,
  listContentBizDetailByPin,
  changheCreatorAccountStatus,
  listContentUserPermissions,
  updateCreatorAccountIdentity,
  queryCreatorAccountCount,
  listContentBusinessForUserMan,
} from "../../../../api/man";

export default {
  name: "userAudit",
  data() {
    return {
      num: 4,
      selectList: {
        article: "",
        expertName: "",
        articleType: "",
        contributeTime: "",
        business: "",
        contentType: "",
        businessId: "",
        pin: "",
      },
      select: [
        {
          prop: "article",
          type: "input",
          placeholder: "请输入用户ID",
        },
        {
          prop: "articleType",
          type: "select",
          placeholder: "请选择角色类型",
          List: [],
        },
        {
          prop: "contributeTime",
          type: "picker",
          placeholder: "请选择申请时间",
        },
        {
          prop: "business",
          type: "input",
          placeholder: "请输入昵称",
          // List: [],
        },
        {
          prop: "pin",
          type: "input",
          placeholder: "请输入用户pin",
          // List: [],
        },
        //  {
        //     prop:'businessId',
        //     type:'select',
        //     placeholder:'请选择所属业务',
        //     List: [],
        // },
      ],
      businessAccountCountStaus: {},
      freeze: {
        freeze: [
          { required: true, message: "请选择活动区域", trigger: "blur" },
        ],
      },
      rules: {
        freeze: [
          { required: true, message: "请填写驳回理由", trigger: "blur" },
        ],
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      width: "414px",
      imgHost: "//image.healthjd.com/da/",
      auditDialog: false,
      editroleDialog: false,
      freezeDialog: false,
      isShowBtn: [true, true],
      btnTextAudit: ["驳回", "通过"],
      btnTextFreeze: ["取消", "确认"],
      btnTextEditrole: ["取消", "确认"],
      btnText: ["取消", "确认"],
      activeName: "all",
      editroleForm: {
        briefing: "",
        applyRemarks: "",
        exampleUrl: "",
        identityCode: "",
      },
      formDialog: false,
      auditForm: {
        briefing: "",
        applyRemarks: "",
        exampleUrl: "",
        identityCode: "",
        Status: -1,
        freeze: "",
      },
      identityList: [],
      accountTypeList: [
        {
          label: "JD账号",
          value: 2,
        },
        {
          label: "ERP账号",
          value: 1,
        },
        {
          label: "其他账号",
          value: 3,
        },
      ],
      // businessList: [],
      freezeForm: {
        freeze: "",
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "用户ID",
            prop: "id",
          },
          {
            label: "头像",
            prop: "headPic",
          },
          {
            label: "京东PIN",
            prop: "pin",
          },
          {
            label: "昵称",
            prop: "nickName",
          },
          {
            label: "个人简介",
            prop: "briefing",
          },
          {
            label: "身份",
            prop: "identity",
          },
          {
            label: "审核时间",
            prop: "auditTime",
          },
          {
            label: "更新时间",
            prop: "updateTime",
          },
          {
            label: "审核人",
            prop: "auditPin",
          },
          {
            label: "状态",
            prop: "auditStatus",
            tableStatus: "auditStatus",
          },
        ],
        tableType: 7,
      },
      isBtn: 1,
      tableVal: {},
      status: {
        auditStatus: "",
        accountStatus: "",
      },
      businessOptions: [],
      businessTag: [],
    };
  },
  components: {
    // search,
    breadCrumb,
    baseTable,
    modal,
    // dialogForm,
    pagination,
    manFormList,
  },
  watch: {
    // 'selectList.article'(newVal,oldVal){
    // console.log(newVal,'watch');
    // if(!this.$utils.checkNumber(newVal)){
    //   this.$message({
    //     message: 'ID只能为数字类型',
    //     type: 'warning'
    //   });
    // }
    // this.$utils.checkNumber(newVal)
    // }
  },
  created() {
    this.pageQueryCreatorAccount();
    this.queryCreatorAccountCount();
    this.queryAllIdentity();
    this.listContentBusinessForUserMan();
  },
  methods: {
    getChangeValue() {
      if (!this.$utils.checkNumber(this.selectList.article)) {
        return this.$message({
          message: "ID只能为数字类型",
          type: "warning",
        });
      }
      (this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      }),
        this.pageQueryCreatorAccount();
    },
    empty() {
      Object.keys(this.selectList).map((item) => {
        this.selectList[item] = "";
      });
      this.pageQueryCreatorAccount();
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageQueryCreatorAccount();
    },
    ClickHandler(type) {
      if (type === "one") {
        this.formDialog = false;
      } else if (type === "two") {
        this.formDialog = false;
      }
    },
    auditClickHandler(type) {
      if (type === "one") {
        if (this.btnTextAudit[0] === "驳回") {
          this.auditForm.Status = 1;
          this.btnTextAudit = ["取消", "确认"];
        } else {
          this.auditDialog = false;
        }
      } else if (type === "two") {
        if (this.btnTextAudit[1] === "通过") {
          this.reviewCreatorAccount(2);
          this.auditDialog = false;
        } else {
          this.$refs.audit.validate((valid) => {
            if (valid) {
              this.reviewCreatorAccount(3);
              this.auditDialog = false;
            } else {
              return false;
            }
          });
        }
      }
    },
    editroleClickHandler(type) {
      if (type === "one") {
        this.editroleDialog = false;
      } else if (type === "two") {
        this.updateCreatorAccountIdentity();
        this.editroleDialog = false;
      }
    },
    freezeClickHandler(type) {
      if (type === "one") {
        this.freezeDialog = false;
      } else if (type === "two") {
        if ($.trim(this.freezeForm.freeze).length == 0) {
          this.$message.error("请输入冻结理由!");
          return;
        }
        this.changheCreatorAccountStatus(3);
        this.freezeDialog = false;
      }
    },
    TabhandleClick(val) {
      this.tableVal = val.val;
      if (val.type === "audit") {
        // 审核
        this.businessTag = val.val.contentBusinessIds || [];
        this.auditForm.identityCode = "";
        this.auditForm.freeze = "";
        this.auditForm.Status = 0;
        this.auditForm.identityCode = val.val.identity;
        this.btnTextAudit = ["驳回", "通过"];
        this.auditForm.applyRemarks = val.val.applyRemarks;
        this.auditForm.briefing = val.val.briefing;
        this.auditForm.exampleUrl = val.val.exampleUrl;
        // val?.val?.businessIds?.length > 0 &&
        //   val?.val?.businessIds.forEach(item => {
        //     this.businessTag.push(item);
        //   });
        this.queryAllIdentity(val.val.pin);
        this.auditDialog = true;
      } else if (val.type === "editrole") {
        this.businessTag = val.val.contentBusinessIds;
        // 修改角色
        this.editroleForm.identityCode = "";
        this.editroleForm.identityCode = val.val.identity;
        this.editroleForm.applyRemarks = val.val.applyRemarks;
        this.editroleForm.briefing = val.val.briefing;
        this.editroleForm.exampleUrl = val.val.exampleUrl;
        this.queryAllIdentity(val.val.pin);
        this.editroleDialog = true;
        // val?.val?.businessIds?.length > 0 &&
        //   val?.val?.businessIds.forEach(item => {
        //     this.businessTag.push(item);
        //   });
      } else if (val.type === "examine") {
        // 查看理由
        this.formDialog = true;
      } else if (val.type === "freeze") {
        // 冻结
        this.freezeForm.freeze = "";
        this.freezeDialog = true;
      } else if (val.type === "thaw") {
        console.log("我是解冻的");
        // 解冻
        this.$confirm("确定要解冻吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.freezeForm.freeze = "";
            this.changheCreatorAccountStatus(2);
            this.$message({
              type: "success",
              message: "解冻成功!",
            });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    selectChenge() {
      // if(this.selectList.contributeTime[1] === null ){
      // }else{
      //   var timetamp3 = Number(this.selectList.contributeTime[1])
      // }
      //
      // this.pageQueryCreatorAccount()
    },
    handleClick(tab, event) {
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };

      if (this.activeName === "all") {
        this.status.auditStatus = "";
        this.status.accountStatus = "";
        this.pageQueryCreatorAccount();
      } else if (this.activeName === "pending") {
        this.status.auditStatus = 1;
        this.status.accountStatus = "";
        this.pageQueryCreatorAccount();
      } else if (this.activeName === "passed") {
        this.status.auditStatus = 2;
        this.status.accountStatus = "";
        this.pageQueryCreatorAccount();
      } else if (this.activeName === "rejected") {
        this.status.auditStatus = 3;
        this.status.accountStatus = "";
        this.pageQueryCreatorAccount();
      } else if (this.activeName === "frozen") {
        this.status.auditStatus = "";
        this.status.accountStatus = 3;
        this.pageQueryCreatorAccount();
      }
    },
    // 获取业务
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((item) => {
          this.businessOptions.push({
            label: item.name,
            value: item.id,
          });
        });
        // this.select[4].List = arr
      });
    },
    // 获取创作者账号全部身份
    queryAllIdentity(pin) {
      queryAllIdentity({
        tenantId: this.$commonJs.getTenantId(),
        // pin: pin,
      }).then((res) => {
        this.identityList = res;
        let arr = [];
        res.map((item) => {
          arr.push({
            value: item.identityCode,
            label: item.identityDesc,
          });
          this.select[1].List = arr;
        });
      });
    },
    // 审核
    reviewCreatorAccount(status) {
      reviewCreatorAccount({
        tenantId: this.$commonJs.getTenantId(),
        creatorAccountId: this.tableVal.id,
        auditStatus: status,
        pin: this.tableVal.pin,
        identity: this.auditForm.identityCode,
        auditRemarks: this.auditForm.freeze,
        businessIds: this.businessTag,
      }).then((res) => {
        // this.activeName = 'all'
        this.pageQueryCreatorAccount();
        // this.queryCreatorAccountCount()
      });
    },

    changheCreatorAccountStatus(status) {
      changheCreatorAccountStatus({
        tenantId: this.$commonJs.getTenantId(),
        id: this.tableVal.id,
        accountStatus: status,
        pin: this.tableVal.pin,
        auditRemark: this.freezeForm.freeze,
      }).then((res) => {
        this.activeName = "all";
        this.pageQueryCreatorAccount();
        // this.queryCreatorAccountCount()
      });
    },
    // 修改创作者账号身份
    updateCreatorAccountIdentity() {
      console.log(this.tableVal);
      updateCreatorAccountIdentity({
        tenantId: this.$commonJs.getTenantId(),
        id: this.tableVal.id,
        identity: this.editroleForm.identityCode,
        pin: this.tableVal.pin,
        contentBusinessIds: this.businessTag,
      }).then((res) => {
        this.pageQueryCreatorAccount();
        // this.queryCreatorAccountCount()
        // this.activeName = 'all'
      });
    },
    //
    queryCreatorAccountCount() {
      queryCreatorAccountCount({
        tenantId: this.$commonJs.getTenantId(),
        creatorAccountId: this.selectList.article,
        identityCode:
          this.selectList.articleType === "全部"
            ? ""
            : this.selectList.articleType,
        startTime: utils.isEmpty(this.selectList.contributeTime)
          ? ""
          : utils.timetamp(Number(this.selectList.contributeTime[0])),
        nickName: this.selectList.business,
        // businessId:this.selectList.businessId,
        // auditStatus:auditStatus,
        // accountStatus:accountStatus,
        endTime: utils.isEmpty(this.selectList.contributeTime)
          ? ""
          : utils.timetamp(Number(this.selectList.contributeTime[1])),
        pin: this.selectList.pin,
      }).then((res) => {
        this.businessAccountCountStaus = res;
      });
    },
    // 分页
    pageQueryCreatorAccount() {
      let vm = this;

      pageQueryCreatorAccount({
        tenantId: this.$commonJs.getTenantId(),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        creatorAccountId: this.selectList.article,
        identityCode:
          this.selectList.articleType === "全部"
            ? ""
            : this.selectList.articleType,
        pin: this.selectList.pin,
        startTime: utils.isEmpty(this.selectList.contributeTime)
          ? ""
          : utils.timetamp(Number(this.selectList.contributeTime[0])),
        nickName: this.selectList.business,
        auditStatus: this.status.auditStatus,
        accountStatus: this.status.accountStatus,
        endTime: utils.isEmpty(this.selectList.contributeTime)
          ? ""
          : utils.timetamp(Number(this.selectList.contributeTime[1])),
        // businessId:this.selectList.businessId
        withBusiness: true,
      }).then((res) => {
        console.log("创作者出参", res);
        vm.tableData.tableList.splice(0, vm.tableData.tableList.length);
        res.data.map((item) => {
          // if(item.headPic){
          item.headPic = this.imgHost + item.headPic;
          // }else{
          //   item.headPic = ""
          // }

          if (item.accountStatus === 3) {
            item.auditStatus = 4;
          } else {
            item.auditStatus = item.auditStatus;
          }
          vm.tableData.tableList.push(item);
        });
        vm.paginationDataProduct.total = res.totalCount;
        vm.paginationDataProduct.currentPage = res.pageNo;
        vm.paginationDataProduct.pageSize = res.pageSize;
        this.queryCreatorAccountCount();
      });
    },
  },
};
</script>
<style scoped lang="scss">
// .el-form-item__content :deep(.el-textarea .el-input--small) {
//     width: 276px !important;
// }
:deep(.el-textarea__inner) {
  // height: 100%;
  min-height: 130px !important;
  // width: 276px !important;
}

.demo-ruleForm {
  padding: 30px;
  padding-left: 0px;
  padding-bottom: 0;
}
.el-input--small :deep(.el-input__inner) {
  width: 215px;
}
.dialog-conter {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}
.rejectInp {
  max-height: 130px;
  max-width: 276px;
  overflow: hidden;
}
:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}
.authorUrl {
  // display: inline-block;
  width: 240px;
  word-wrap: break-word;
  word-break: normal;
  // line-height: 1px;
}
</style>
